import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../clearButtonAction';
import fetchApi from "./fetchApi";

function fetchClearButtonAction() {
  return fetchApi('/v1/fc_api/clear_button_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchClearButtonAction;
